
import { useState } from "react";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogTrigger,
} from "@/components/ui/dialog";
import { DiscountForm } from "./DiscountForm";
import { DiscountFormValues } from "@/types/discount";

interface CreateDiscountDialogProps {
  onDiscountCreated: () => void;
}

export const CreateDiscountDialog = ({ onDiscountCreated }: CreateDiscountDialogProps) => {
  const [open, setOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const initialValues: DiscountFormValues = {
    school_id: "",
    discount_type: "percentage",
    discount_value: 0,
    status: "active",
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button>
          <Plus className="mr-2 h-4 w-4" />
          Add Discount
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Create New Discount</DialogTitle>
          <DialogDescription>
            Add a discount for a specific school, product, or plan.
          </DialogDescription>
        </DialogHeader>
        <DiscountForm
          initialValues={initialValues}
          isSubmitting={isSubmitting}
          setIsSubmitting={setIsSubmitting}
          onSuccess={() => {
            onDiscountCreated();
            setOpen(false);
          }}
          mode="create"
        />
      </DialogContent>
    </Dialog>
  );
};
